import React, { useEffect } from 'react'
import DetalleZarandeoView from '../../components/listados/DetalleZarandeoView'
import { obtenerDetalleZarandeo } from '../../actions/listados'
import { connect } from 'react-redux'

function DetalleZarandeo (props) {
  const { fecha, exportador, cereal, obtenerDetalleZarandeo } = props

  useEffect(() => {
    obtenerDetalleZarandeo(fecha, exportador, cereal)
  }, [obtenerDetalleZarandeo, fecha, exportador, cereal])

  return (
    <DetalleZarandeoView />
  )
}

const mapActionsToProps = {
  obtenerDetalleZarandeo
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(DetalleZarandeo)
